import React from 'react';
import './RestaurantName.less';

export const RestaurantName = ({text}) => {
	return <h2 className="restaurant-name">{text}</h2>
}
